"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _reactToastify = require("react-toastify"),
    _uiKit = require("@devsta/ui-kit");

function getClickHandler(_ref) {
  var history = _ref.history,
      link = _ref.link,
      windowLink = _ref.windowLink;
  return history && link ? function (_ref2) {
    var target = _ref2.target;
    target.classList.contains("icon") || history.push(link);
  } : windowLink ? function () {
    window.location.href = windowLink;
  } : function () {};
}

var defaults = function defaults() {
  var params = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  return {
    hideProgressBar: !0,
    closeButton: _react["default"].createElement(_uiKit.Icon, {
      name: "close",
      size: 10,
      color: "white"
    }),
    draggable: !1,
    transition: _reactToastify.Slide,
    onClick: getClickHandler(params)
  };
};

function buildContent(content, title) {
  return _react["default"].createElement("div", {
    className: "Toastify__toast__content"
  }, title ? _react["default"].createElement("p", {
    className: "Toastify__toast__content__title"
  }, title) : null, _react["default"].createElement("p", {
    className: "Toastify__toast__content__text"
  }, content));
}

function getDefaultTitleFromType(type, title) {
  return title ? title : "error" === type ? "Something went wrong..." : "success" === type ? "Success!" : null;
}

function notify(params) {
  if ("string" == typeof params) return void _reactToastify.toast.info(buildContent(params), defaults());
  var content = params.content,
      _params$type = params.type,
      type = void 0 === _params$type ? "info" : _params$type,
      history = params.history,
      link = params.link,
      windowLink = params.windowLink,
      defaultProps = defaults({
    history: history,
    link: link,
    windowLink: windowLink
  }),
      title = getDefaultTitleFromType(type, params.title);
  return "success" === type ? void _reactToastify.toast.success(buildContent(content, title), defaultProps) : "warn" === type ? void _reactToastify.toast.warn(buildContent(content, title), defaultProps) : "error" === type ? void _reactToastify.toast.error(buildContent(content, title), defaultProps) : void _reactToastify.toast.info(buildContent(content, title), defaultProps);
}

var _default = notify;
exports["default"] = _default;